@if (canViewFirmwareMaster) {
  <div class="main-container">
    @if (viewType === 'List') {
      <div class="page-header">
        <div class="routing-buttons">
          <div
            class="action-button back-button"
            (click)="navigateBack()"
            tabindex="0"
            (keydown.enter)="navigateBack()"
          >
            <mat-icon class="icon back-icon">arrow_back</mat-icon>
          </div>
          <div
            class="action-button reload-button"
            (click)="ngOnInit()"
            tabindex="0"
            (keydown.enter)="ngOnInit()"
          >
            <mat-icon class="icon reload-icon">refresh</mat-icon>
          </div>
          <span class="page-title">Firmware Master</span>
        </div>

        @if (canCreateFirmwareMaster) {
          <div class="button-group">
            <button class="primary-button" (click)="addFirmware('Add')">
              Add Firmware
              <mat-icon class="btn-icon">open_in_new</mat-icon>
            </button>
          </div>
        }
      </div>

      <div class="component-container">
        <!-- Component Header Section -->
        <div class="component-header">
          <h6 class="component-title">Firmware List</h6>
          <div class="component-actions">
            <app-common-search
              (searchSubmit)="onSearchInputChange($event)"
            ></app-common-search>
          </div>
        </div>

        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>

        <!-- Component Body Section -->
        <div class="component-body">
          <table>
            <thead>
              <tr>
                <th>Firmware Type</th>
                <th>Firmware Version</th>
                <th>Upload File / File Name</th>
                <th>Description</th>
                <th>Release Date</th>
                <th>Created By</th>
                <th>Action</th>
              </tr>
            </thead>
            @if (displayedItems.length > 0) {
              <tbody>
                @for (item of displayedItems; track item) {
                  <tr>
                    <td>
                      {{ item.firmwareType === 'D' ? 'Device' : 'Open CPU' }}
                    </td>
                    <td>{{ item.firmwareName }}</td>
                    <td>{{ item.fileName }}</td>
                    <td>{{ item.description }}</td>
                    <td>{{ item.releaseDate | date: 'yyyy-MM-dd' }}</td>
                    <td>{{ item.createdBy }}</td>
                    <td>
                      <div class="action-buttons">
                        <button
                          class="primary-button view-button"
                          (click)="viewFMDetails(item.id)"
                        >
                          <mat-icon class="btn-icon">visibility</mat-icon>
                        </button>
                        @if (canDeleteFirmwareMaster) {
                          <button
                            class="primary-button delete-button"
                            (click)="deleteFirmware(item.id)"
                          >
                            <mat-icon class="btn-icon">delete</mat-icon>
                          </button>
                        }
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            }
            @if (displayedItems.length === 0) {
              <tbody>
                <tr>
                  <td colspan="12">
                    <img
                      loading="lazy"
                      class="no-data-img"
                      src="../../assets/dataNotFound.jpg"
                      alt="No Data Found"
                    />
                  </td>
                </tr>
              </tbody>
            }
          </table>
        </div>

        <div class="component-separator"></div>
        <!-- Component Footer Section (Optional) -->
        <div class="component-footer">
          @if (displayedItems.length > 0) {
            <app-common-component-pagination
              [totalItems]="totalItems"
              [pageSize]="pageSize"
              [currentPage]="currentPage"
              [totalPages]="totalPages"
              (pageChange)="onPageChange($event)"
              (sizeChange)="onSizeChange($event)"
            >
            </app-common-component-pagination>
          }
        </div>
      </div>
    }

    @if (viewType === 'Details') {
      <div class="page-header">
        <div class="routing-buttons">
          <div
            class="action-button back-button"
            (click)="onBack()"
            tabindex="0"
            (keydown.enter)="onBack()"
          >
            <mat-icon class="icon back-icon">arrow_back</mat-icon>
          </div>
          <div
            class="action-button reload-button"
            (click)="onRefresh()"
            tabindex="0"
            (keydown.enter)="onRefresh()"
          >
            <mat-icon class="icon reload-icon">refresh</mat-icon>
          </div>
          <span class="page-title">{{ firmwarePageTitle }}</span>
        </div>
      </div>

      <div class="component-container">
        <div class="component-header">
          <h6 class="component-title">Firmware Details</h6>
        </div>

        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>

        <!-- Component Body Section -->
        <div class="component-body">
          <form [formGroup]="addUpdateFirmwareForm" novalidate>
            <div class="form-section">
              <!-- Firmware Name -->
              <div class="form-group">
                <label for="firmwareName" class="form-label"
                  >Firmware Version/UFW</label
                >
                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>Firmware Version/UFW</mat-label>
                  <input
                    id="firmwareName"
                    placeholder="Firmware Version/UFW"
                    formControlName="firmwareName"
                    matInput
                    type="text"
                    required
                    [readonly]="firmwareFormType === 'View'"
                  />
                  @if (
                    addUpdateFirmwareForm.controls['firmwareName'].touched &&
                    addUpdateFirmwareForm.controls['firmwareName'].errors
                      ?.requiredAndNoEmptySpaces
                  ) {
                    <mat-error>
                      {{
                        addUpdateFirmwareForm.controls['firmwareName'].errors
                          ?.requiredAndNoEmptySpaces
                      }}
                    </mat-error>
                  }
                  @if (
                    addUpdateFirmwareForm.controls['firmwareName'].touched &&
                    addUpdateFirmwareForm.controls['firmwareName'].errors
                      ?.rangeLength
                  ) {
                    <mat-error>
                      {{
                        addUpdateFirmwareForm.controls['firmwareName'].errors
                          ?.rangeLength
                      }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <!-- Firmware Description -->
              <div class="form-group">
                <label for="description" class="form-label"
                  >Firmware Description</label
                >
                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>Firmware Description</mat-label>
                  <input
                    id="description"
                    placeholder="Firmware Description"
                    formControlName="description"
                    matInput
                    type="text"
                    required
                    [readonly]="firmwareFormType === 'View'"
                  />
                  @if (
                    addUpdateFirmwareForm.controls['description'].touched &&
                    addUpdateFirmwareForm.controls['description'].errors
                      ?.requiredAndNoEmptySpaces
                  ) {
                    <mat-error>
                      {{
                        addUpdateFirmwareForm.controls['description'].errors
                          ?.requiredAndNoEmptySpaces
                      }}
                    </mat-error>
                  }
                  @if (
                    addUpdateFirmwareForm.controls['description'].touched &&
                    addUpdateFirmwareForm.controls['description'].errors
                      ?.rangeLength
                  ) {
                    <mat-error>
                      {{
                        addUpdateFirmwareForm.controls['description'].errors
                          ?.rangeLength
                      }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <!-- Upload File -->
              @if (firmwareFormType === 'Add') {
                <div class="form-group">
                  <label for="fileName" class="form-label">Upload File</label>
                  <mat-form-field
                    class="file-upload-container"
                    appearance="outline"
                  >
                    <mat-label>Upload File</mat-label>

                    <!-- Display File Name or Placeholder -->
                    <input
                      matInput
                      type="text"
                      formControlName="fileName"
                      readonly
                    />

                    <!-- Hidden File Input -->
                    <input
                      type="file"
                      accept=".pak,.bin,.pac,.tar"
                      aria-label="File"
                      class="d-none"
                      (change)="file_upload($event)"
                      #fileInput
                    />

                    <!-- Custom Upload Button -->
                    <button
                      mat-button
                      class="upload-btn"
                      (click)="fileInput.click()"
                      type="button"
                    >
                      <mat-icon>attach_file</mat-icon>
                    </button>

                    @if (addUpdateFirmwareForm.controls['fileName'].touched) {
                      <mat-error>
                        @if (
                          addUpdateFirmwareForm.controls['fileName'].errors;
                          as errors
                        ) {
                          @if (errors['required']) {
                            <span>This field is mandatory.</span>
                          }
                        }
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              }
              <!-- File Uploaded Name -->
              @if (firmwareFormType === 'View') {
                <div class="form-group">
                  <label for="description" class="form-label"
                    >Uploaded File Name</label
                  >
                  <mat-form-field class="form-field" appearance="outline">
                    <mat-label>Uploaded File Name</mat-label>
                    <input
                      id="fileName"
                      placeholder="Uploaded File Name"
                      formControlName="fileName"
                      matInput
                      type="text"
                      required
                      [readonly]="true"
                      [readonly]="firmwareFormType === 'View'"
                    />
                    @if (addUpdateFirmwareForm.controls['fileName'].touched) {
                      <mat-error>
                        @if (
                          addUpdateFirmwareForm.controls['fileName'].errors;
                          as errors
                        ) {
                          @if (errors['required']) {
                            <span>This field is mandatory.</span>
                          }
                        }
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              }
              <!-- Release Date -->
              <div class="form-group">
                <label for="releaseDate" class="form-label">Release Date</label>
                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>Release Date</mat-label>
                  <input
                    id="releaseDate"
                    matInput
                    [matDatepicker]="releaseDatePicker"
                    formControlName="releaseDate"
                    placeholder="Release Date (DD/MM/YYYY)"
                    required
                    readonly
                    [max]="today"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="releaseDatePicker"
                    [disabled]="firmwareFormType === 'View'"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #releaseDatePicker></mat-datepicker>
                  @if (
                    addUpdateFirmwareForm.controls['releaseDate'].touched &&
                    addUpdateFirmwareForm.controls['releaseDate'].errors?.[
                      'required'
                    ]
                  ) {
                    <mat-error> Please select a valid date. </mat-error>
                  }
                </mat-form-field>
              </div>

              @if (firmwareFormType === 'Add' && serverName === 'LCT-A4G') {
                <div class="form-group">
                  <label for="type" class="form-label">Firmware Type</label>
                  <mat-form-field appearance="outline">
                    <mat-label>Firmware Type</mat-label>
                    <mat-select formControlName="firmwareType" required>
                      @for (type of firmwareTypes; track type) {
                        <mat-option [value]="type.value">
                          {{ type.name }}
                        </mat-option>
                      }
                    </mat-select>
                    @if (
                      addUpdateFirmwareForm.controls['firmwareType'].touched &&
                      addUpdateFirmwareForm.controls['firmwareType'].errors?.[
                        'required'
                      ]
                    ) {
                      <mat-error> This field is mandatory. </mat-error>
                    }
                  </mat-form-field>
                </div>
              }
              @if (firmwareFormType === 'View' && serverName === 'LCT-A4G') {
                <div class="form-group">
                  <label for="type" class="form-label">Firmware Type</label>
                  <mat-form-field appearance="outline">
                    <mat-label>Firmware Type</mat-label>
                    <input
                      id="firmwareType"
                      placeholder="Firmware Type"
                      formControlName="firmwareType"
                      matInput
                      type="text"
                      required
                      [readonly]="firmwareFormType === 'View'"
                    />
                  </mat-form-field>
                </div>
              }
            </div>
          </form>
        </div>
        <div class="component-separator"></div>
        <div class="component-footer">
          <div class="button-group">
            @if (firmwareFormType === 'Add' && canCreateFirmwareMaster) {
              <button
                class="submit-button"
                (click)="submitFirmwareDetails()"
                [disabled]="this.addUpdateFirmwareForm.invalid"
              >
                Submit <mat-icon class="btn-icon">check_circle</mat-icon>
              </button>
            }
          </div>
        </div>
      </div>
    }
  </div>
}
